import Vue from 'vue'
import App from './App.vue'
import store from "../store"
import vuetify from "./template/plugins/vuetify";
import Vuetify from "vuetify";
import router from "./router";
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from "axios";
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css';

import VueQuillEditor from 'vue-quill-editor';

import VueCookies from 'vue-cookies';

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(Vuetify)
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB7OXmzfQYua_1LEhRdqsoYzyJOPh9hGLg',
    },
});
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.use(VueCookies);

new Vue({
    vuetify,
    router,
    axios,
    render: h => h(App), store
}).$mount('#app');
